module.exports = __webpack_public_path__ + "img/slide-2.d0d20078.jpg";